<template>
  <div class="menuFrame">
    <!-- <loading :active.sync="isLoading"></loading> -->

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">Booth Events</a>
          <span>/</span> Add Booth Event
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div>
        <div
          class="contentBoxStatus"
          style="border-radius: 5px; padding-bottom: 20px"
        >
          <h1>Add Booth Event</h1>
          <p class="my-3">&nbsp;</p>

          <div>
            <div class="alert">
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                All booth events organized and conducted by exhibitors must
                comply with the laws and regulations of the Republic of China
                (Taiwan) or the host country/region of the exhibition. Events
                shall not involve or include any content deemed immoral,
                obscene, violent, gambling-related, infringing, or otherwise
                unlawful.
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                The Organizer provides only the exhibition website platform and
                assumes no responsibility or guarantee regarding the content,
                quality, or legality of events conducted at individual booths.
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                In the event of any improper or non-compliant events, the
                Organizer reserves the right to immediately suspend such events
                or revoke the exhibitor’s participation.
              </div>
            </div>
          </div>
        </div>
        <p class="my-3 PcDevice">&nbsp;</p>

        <div>
          <form
            name="_method"
            id="form"
            enctype="multipart/form-data"
            @submit.prevent="AddNewEvent"
          >
            <input type="hidden" name="RegNo" value="" />
            <!-- left -->
            <!-- PC版圖片顯示 -->

            <div class="proLeft PcDevice">
              <div
                class="contentBoxStatus"
                style="border-radius: 5px; padding-bottom: 20px"
              >
                <div
                  class="mt-2 mb-3 border text-center py-2"
                  style="border-radius: 30px"
                >
                  <div class="d-flex align-items-center justify-content-center">
                    <span
                      v-if="modelSrc !== noImageSrc"
                      class="complete mr-1"
                    ></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span style="color: black">Upload Image </span>
                  </div>
                </div>
                <label class="inputFile">
                  <div
                    class="squareThumb pointer ImgHoverStyle"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Select Image"
                    v-if="hasImgfile"
                  >
                    <img :src="modelSrc" class="img-fluid" />
                  </div>

                  <div
                    class="squareThumb pointer ImgHoverStyle"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Select Image"
                    v-else
                  >
                    <img
                      src="../../../assets/images/default.jpg"
                      class="img-fluid"
                    />
                  </div>

                  <span name="showName" class="nowrap"></span>

                  <input
                    type="file"
                    accept=".jpg,.jpeg,.webp"
                    class="textStyle maxText"
                    @change="uploadImgPC($event)"
                  />
                  <p class="divider"></p>

                  <div class="d-flex justify-content-around">
                    <div>
                      <p class="align_c">
                        <span class="btnStyle btnGray">Select</span>
                      </p>
                    </div>
                    <div v-if="modelSrc !== noImageSrc">
                      <p class="align_c">
                        <span class="btnStyle btnRed" @click.prevent="resetImg"
                          >Reset
                        </span>
                      </p>
                    </div>
                  </div>
                </label>
                <p class="my-3">&nbsp;</p>
                <p class="italic">File Size：Maximum 3MB</p>
                <p class="italic">File Format：JPG、WEBP</p>
                <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
              </div>
            </div>
            <!-- 行動版圖片顯示 -->

            <div class="contentBoxStatus MbDevice">
              <div class="proLeft">
                <label class="inputFile pointer">
                  <div class="squareThumb" v-if="hasImgfile">
                    <img :src="modelSrc" class="img-fluid" />
                  </div>
                  <div class="squareThumb" v-else>
                    <img
                      src="../../../assets/images/default.jpg"
                      class="img-fluid"
                    />
                  </div>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.webp"
                    class="textStyle maxText"
                    @change="uploadImgMb($event)"
                  />
                  <p class="divider"></p>
                  <div class="d-flex justify-content-around">
                    <p class="align_c">
                      <span class="btnStyle btnGray">Select</span>
                    </p>
                    <div v-if="modelSrc !== noImageSrc">
                      <p class="align_c">
                        <span class="btnStyle btnRed" @click.prevent="resetImg"
                          >Reset
                        </span>
                      </p>
                    </div>
                  </div>
                </label>
                <p class="my-3">&nbsp;</p>
                <p class="italic">File Size：Maximum 3MB</p>
                <p class="italic">File Format：JPG、WEBP</p>
                <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
              </div>
            </div>

            <!-- left end -->
            <!-- right -->
            <div class="proRight">
              <div
                class="contentBoxStatus"
                style="border-radius: 5px; padding-bottom: 20px"
              >
                <div
                  class="mt-2 mb-3 border text-center py-2 PcDevice"
                  style="border-radius: 30px"
                >
                  <div class="d-flex align-items-center justify-content-center">
                    <span
                      v-if="!eEventName || !eEventDesc || !hasAnyDayChecked"
                      class="uncomplete mr-1"
                    ></span>
                    <span v-else class="complete mr-1"></span>
                    <span style="color: black">Booth Events </span>
                  </div>
                </div>

                <p class="formTitle">Display</p>
                <div class="form-check-inline">
                  <div class="formstatus">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="Radios"
                      id="yes"
                      :value="true"
                      v-model="EventArchive"
                    />
                    <label class="form-check-label" for="yes"> Show</label>
                  </div>
                  <div class="ml-2">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="Radios"
                      id="no"
                      :value="false"
                      v-model="EventArchive"
                    />
                    <label class="form-check-label" for="no"> Hide </label>
                  </div>
                </div>
                <p class="my-3">&nbsp;</p>
                <p class="formTitle">Event Name <span class="red">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="eEventName"
                    class="textStyle maxText"
                    maxlength="100"
                    required
                    placeholder=""
                    v-model="eEventName"
                  />
                  <span>EN</span>
                </div>
                <p class="divider"></p>

                <div class="langTip">
                  <input
                    type="text"
                    name="EventName"
                    class="textStyle maxText"
                    maxlength="50"
                    placeholder=""
                    v-model="EventName"
                  />
                  <span>CN</span>
                </div>

                <p class="my-3">&nbsp;</p>

                <p class="formTitle">Event Time <span class="red">*</span></p>
                <div v-if="EventDatesList[0]" class="d-flex align-items-center">
                  <!-- 勾選：啟用這天 -->
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'day1-check'"
                      v-model="day1.enabled"
                    />
                    <label
                      class="form-check-label"
                      :for="'day1-check'"
                      style="width: 85px; font-weight: 600"
                    >
                      {{ EventDatesList[0] }}
                    </label>
                  </div>

                  <div class="d-flex align-items-center ml-2">
                    <div>Start Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day1.startTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day1.enabled"
                      :class="{ 'is-invalid': day1.enabled && !isDay1Valid }"
                    ></vue-timepicker>

                    <div class="ml-2">End Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day1.endTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day1.enabled"
                      :class="{ 'is-invalid': day1.enabled && !isDay1Valid }"
                    ></vue-timepicker>
                  </div>
                </div>
                <div v-if="EventDatesList[1]" class="d-flex align-items-center">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'day2-check'"
                      v-model="day2.enabled"
                    />
                    <label
                      class="form-check-label"
                      :for="'day2-check'"
                      style="width: 85px; font-weight: 600"
                    >
                      {{ EventDatesList[1] }}
                    </label>
                  </div>

                  <div class="d-flex align-items-center ml-2">
                    <div>Start Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day2.startTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day2.enabled"
                      :class="{ 'is-invalid': day2.enabled && !isDay2Valid }"
                    ></vue-timepicker>

                    <div class="ml-2">End Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day2.endTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day2.enabled"
                      :class="{ 'is-invalid': day2.enabled && !isDay2Valid }"
                    ></vue-timepicker>
                  </div>
                </div>
                <div v-if="EventDatesList[2]" class="d-flex align-items-center">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'day3-check'"
                      v-model="day3.enabled"
                    />
                    <label
                      class="form-check-label"
                      :for="'day3-check'"
                      style="width: 85px; font-weight: 600"
                    >
                      {{ EventDatesList[2] }}
                    </label>
                  </div>

                  <div class="d-flex align-items-center ml-2">
                    <div>Start Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day3.startTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day3.enabled"
                      :class="{ 'is-invalid': day3.enabled && !isDay3Valid }"
                    ></vue-timepicker>

                    <div class="ml-2">End Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day3.endTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day3.enabled"
                      :class="{ 'is-invalid': day3.enabled && !isDay3Valid }"
                    ></vue-timepicker>
                  </div>
                </div>
                <div v-if="EventDatesList[3]" class="d-flex align-items-center">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'day4-check'"
                      v-model="day4.enabled"
                    />
                    <label
                      class="form-check-label"
                      :for="'day4-check'"
                      style="width: 85px; font-weight: 600"
                    >
                      {{ EventDatesList[3] }}
                    </label>
                  </div>

                  <div class="d-flex align-items-center ml-2">
                    <div>Start Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day4.startTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day4.enabled"
                      :class="{ 'is-invalid': day4.enabled && !isDay4Valid }"
                    ></vue-timepicker>

                    <div class="ml-2">End Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day4.endTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day4.enabled"
                      :class="{ 'is-invalid': day4.enabled && !isDay4Valid }"
                    ></vue-timepicker>
                  </div>
                </div>
                <div v-if="EventDatesList[4]" class="d-flex align-items-center">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'day5-check'"
                      v-model="day5.enabled"
                    />
                    <label
                      class="form-check-label"
                      :for="'day5-check'"
                      style="width: 85px; font-weight: 600"
                    >
                      {{ EventDatesList[4] }}
                    </label>
                  </div>

                  <div class="d-flex align-items-center ml-2">
                    <div>Start Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day5.startTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day5.enabled"
                      :class="{ 'is-invalid': day5.enabled && !isDay5Valid }"
                    ></vue-timepicker>

                    <div class="ml-2">End Time：</div>
                    <vue-timepicker
                      :minute-interval="10"
                      v-model="day5.endTime"
                      format="HH:mm"
                      placeholder="HH:mm"
                      :disabled="!day5.enabled"
                      :class="{ 'is-invalid': day5.enabled && !isDay5Valid }"
                    ></vue-timepicker>
                  </div>
                </div>

                <p class="clear"></p>

                <p class="my-3">&nbsp;</p>
                <p class="formTitle">
                  Event Description (English) <span class="red">*</span>
                </p>
                <textarea
                  name="eEventDesc"
                  rows="4"
                  class="maxText textStyle"
                  placeholder=""
                  v-model="eEventDesc"
                  maxlength="500"
                  required
                ></textarea>
                <p class="grayBG">Max. 500 characters</p>
                <p class="my-3">&nbsp;</p>
                <p class="formTitle">Event Description (Chinese)</p>
                <textarea
                  name="EventDesc"
                  rows="4"
                  class="maxText textStyle"
                  placeholder=""
                  v-model="EventDesc"
                  maxlength="200"
                ></textarea>
                <p class="grayBG">Max. 200 characters</p>

                <p class="my-3">&nbsp;</p>

                <p class="formTitle">Event Disclaimer (English)</p>
                <textarea
                  name="eProWarning"
                  rows="4"
                  class="maxText textStyle"
                  placeholder=""
                  v-model="eEventRemind"
                  maxlength="400"
                ></textarea>

                <p class="grayBG">Max. 400 characters</p>

                <p class="my-3">&nbsp;</p>

                <p class="formTitle">Event Disclaimer (Chinese)</p>
                <textarea
                  name="ProWarning"
                  rows="4"
                  class="maxText textStyle"
                  placeholder=""
                  v-model="EventRemind"
                  maxlength="200"
                ></textarea>

                <p class="grayBG">Max. 200 characters</p>

                <p class="my-3">&nbsp;</p>
              </div>
            </div>
            <!-- right end -->
            <p class="clear"></p>
            <p class="PcDevice my-4">&nbsp;</p>
            <div class="text-center PcDevice mb-4">
              <button class="btn btn-lg btn-primary mr-4" type="submit">
                Confirm
              </button>
              <button
                class="btn btn-lg btn-secondary"
                @click.prevent="backEventPage"
              >
                Back
              </button>
            </div>

            <div class="text-center mb-4 MbDevice">
              <button class="btn btn-primary mr-2" type="submit">
                Confirm
              </button>
              <button class="btn btn-secondary" @click.prevent="backEventPage">
                Back
              </button>
            </div>
          </form>
        </div>

        <!-- 桌機板裁切工具 Modal  -->
        <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <div class="modal-title" style="font-size: 25px">
                  <div class="d-flex align-self-center">
                    <div class="mr-3">
                      <img
                        src="../../../assets/images/cropImg.png"
                        width="30px"
                      />
                    </div>
                    <div style="font-size: 25px">Edit Image</div>
                  </div>
                </div>
                <div
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>

                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          Rotate Left
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-2">
                          Rotate Right
                        </button>
                        <button
                          @click="changeScale(1)"
                          class="btn btn-info ml-2"
                        >
                          +
                        </button>
                        <button
                          @click="changeScale(-1)"
                          class="btn btn-info ml-2"
                        >
                          -
                        </button>
                      </div>
                      <div>
                        <button
                          @click="refreshCrop"
                          class="btn btn-outline-info ml-5"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :style="previewStyle1" class="ImgPreCrop">
                      <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <div class="modal-footer">
                <div>
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-primary btn-lg mr-2"
                    @click="OutputPC()"
                  >
                    Crop
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <p>
                  &middot; Automatically resize your image into square image.
                </p>
                <p>
                  &middot; If you need to crop or edit your image, please use
                  the computer to upload your image.
                </p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="cropperMb"
                  class="btn btn-sm btn-primary"
                  @click="OutputMb()"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "Add Booth Event - Chan Chao Exhibitor's Online Service System",
    };
  },

  data() {
    return {
      UserId: "",
      showImg: false,
      CSRF_Token: "",
      RegNo: "",
      EventArchive: true,
      EventName: "",
      EventDesc: "", //活動說明
      eEventName: "",
      eEventDesc: "", //活動說明 EN
      eEventRemind: "",
      modelSrc: "../../../assets/images/default.jpg",
      noImageSrc: "../../../assets/images/default.jpg",

      modelEnSrc: "../../../assets/images/default.jpg",
      noImageEnSrc: "../../../assets/images/default.jpg",

      previews: {},
      previewStyle1: {},
      lang: "tw",

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: true, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: true, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: true, // 上传图片按照原始比例渲染

        size: 1, //裁剪生成图片的质量V
        outputType: "webp", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      hasImgfile: false,

      LocalExh: true,
      EventDatesList: [],

      // 你原本的
      day1: { enabled: false, startTime: "", endTime: "" },
      day2: { enabled: false, startTime: "", endTime: "" },
      day3: { enabled: false, startTime: "", endTime: "" },
      day4: { enabled: false, startTime: "", endTime: "" },
      day5: { enabled: false, startTime: "", endTime: "" },

      EventDatesRaw: [], // ★ 新增：送 API 用：例如 "2025/11/20"

      EventRemind: "",
    };
  },

  computed: {
    // 基本驗證：若啟用，需有 start/end 且 start < end
    isDay1Valid() {
      if (!this.day1.enabled) return true;
      if (!this.day1.startTime || !this.day1.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day1.startTime) < toMin(this.day1.endTime);
    },
    isDay2Valid() {
      if (!this.day2.enabled) return true;
      if (!this.day2.startTime || !this.day2.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day2.startTime) < toMin(this.day2.endTime);
    },
    isDay3Valid() {
      if (!this.day3.enabled) return true;
      if (!this.day3.startTime || !this.day3.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day3.startTime) < toMin(this.day3.endTime);
    },
    isDay4Valid() {
      if (!this.day4.enabled) return true;
      if (!this.day4.startTime || !this.day4.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day4.startTime) < toMin(this.day4.endTime);
    },

    isDay5Valid() {
      if (!this.day5.enabled) return true;
      if (!this.day5.startTime || !this.day5.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day5.startTime) < toMin(this.day5.endTime);
    },

    TimesForApi() {
      const days = [this.day1, this.day2, this.day3, this.day4, this.day5];
      const result = [];

      days.forEach((d, idx) => {
        const date = this.EventDatesRaw?.[idx]; // YYYY/MM/DD
        if (!date) return; // 沒有日期就跳過

        const hasTime = d.startTime || d.endTime;

        // 規則：勾選的要存；或沒勾選但有填時間也要存
        if (d.enabled || hasTime) {
          result.push({
            Date: date,
            StartTime: d.startTime || "",
            EndTime: d.endTime || "",
            Enable: !!d.enabled,
          });
        }
      });

      return result;
    },

    hasAnyDayChecked() {
      // 判斷是否有至少一天「勾選」且「有填開始/結束時間」
      const days = [this.day1, this.day2, this.day3, this.day4, this.day5];
      return days.some((day) => {
        return day.enabled && day.startTime && day.endTime;
      });
    },
  },

  methods: {
    resetImg() {
      const vm = this;
      vm.modelSrc = "../../../assets/images/default.jpg";
      vm.hasImgfile = false;
    },

    AddNewEvent() {
      const vm = this;

      if (vm.hasAnyDayChecked) {
        const url = "/apiExhibitors/BoothEvent/";

        const info = {
          RegNo: vm.RegNo,
          BoothEventID: "",
          IsShow: vm.EventArchive,

          EventPic: vm.modelSrc,
          BoothEventName: vm.EventName,
          BoothEventEName: vm.eEventName,
          BoothEventDesc: vm.EventDesc,
          BoothEventEDesc: vm.eEventDesc,
          BoothEventRemind: vm.EventRemind,
          BoothEventERemind: vm.eEventRemind,
          Times: vm.TimesForApi,
          CSRF: vm.CSRF_Token,
        };

        if (vm.modelSrc == "../../../assets/images/default.jpg") {
          alert("Must provide image, please check again！");
        } else {
          if (!vm.eEventName || !vm.eEventDesc) {
            alert("There are incomplete fields, please check again.");
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert("You have successfully added a booth event！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("The system is busy, please try again later.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
              } else if (response.data.Code == 401) {
                alert("Missing fields or invalid format.");
              } else if (response.data.Code == 402) {
                alert("Failed to save image. Please try again.");
              } else if (response.data.Code == 403) {
                alert("Invalid image format. Please use JPG, PNG, or GIF.");
              } else if (response.data.Code == 405) {
                alert("No image uploaded. Please select a file.");
              } else if (response.data.Code == 406) {
                alert("You have exceeded the maximum limit of activities.");
              } else if (response.data.Code == 404) {
                alert("404 not found！");
              }
            });
          }
        }
      } else {
        alert(
          "Please select at least one day and fill in the complete start and end times！",
        );
      }
    },

    uploadImgPC(e) {
      const vm = this;

      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or WebP！");
        return false;
      }

      var reader = new FileReader();

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;
        if (isLt5M) {
          $("#cropImagePop").modal("show");

          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result]),
            );
          });
        } else {
          alert("Maximum file size : 3MB");
        }
      };

      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadImgMb(e) {
      const vm = this;

      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or WebP！");
        return false;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("Maximum file size : 3MB");
        }
      };

      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.hasImgfile = true;
          vm.option.img = "/";
        });
        $("#cropImagePop").modal("hide");

        window.setTimeout(
          () =>
            alert(
              `The picture uploaded successfully. Please also fill out the booth events information required, and click "Confirm" to complete the process.`,
            ),
          1000,
        );
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    // 实时预览函数
    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    backEventPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    $("body").tooltip({ selector: "[data-toggle=tooltip]" });

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=en`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }

          const begin = new Date(response.data.Data.ExhBegin);
          const end = new Date(response.data.Data.ExhEnd);

          // 英文簡寫星期
          const weekMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

          const showDates = [];
          const rawDates = [];

          // 走訪每一天
          for (let d = new Date(begin); d <= end; d.setDate(d.getDate() + 1)) {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            const w = weekMap[d.getDay()];

            showDates.push(`${m}/${dd}(${w})`); // 顯示用
            rawDates.push(`${y}/${m}/${dd}`); // 送 API 用
          }

          this.EventDatesList = showDates;
          this.EventDatesRaw = rawDates;

          //取得活動列表
          let url = `https://www.chanchao.com.tw/apiExhibitors/BoothEvent/${vm.RegNo}?mode=list&Page=&Lang=en`;

          axios.get(url).then(function (response) {
            if (response.data.Code == 200) {
              let totalNo = response.data.datatotal;

              //取得活動列表
              let url2 = `https://www.chanchao.com.tw/apiExhibitors/VIP/Info/${vm.RegNo}`;

              axios.get(url2).then(function (res) {
                if (res.data.Code == 200) {
                  // 不論 VipLevel 是多少，邏輯完全一致，直接合併判斷
                  if (totalNo >= res.data.Data.BoothEventAmount) {
                    alert(
                      "You have reached the maximum number of events you can add",
                    );
                    document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
                  }
                }
              });
            }
          });
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert("The system is busy, please try again later");
        }
      });
  },
};
</script>

<style lang="scss">
.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}
.form-control {
  height: calc(2.2em + 0.75rem + 2px);
}

.modal-xl {
  max-width: 940px;
}

.proRight {
  border-left: 0px solid #dadce0;
}

.proLeft {
  padding-right: 0px;
}

.uncomplete {
  background-image: url("../../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.custom-control-label {
  font-size: 15px;
}

.el-collapse-item__header {
  font-size: 17px;
  font-weight: 550;
}

.vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 70px !important;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;

  /* 你要的修改 */
  border-radius: 3px; /* 圓潤度調高 */
  margin-bottom: 3px; /* mb-2 的效果 (大概 0.5rem ≈ 8px) */
}

.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 70px !important;
  font-family: sans-serif;
  vertical-align: middle;
}
</style>
